import React from 'react';
import { Tabs, Tab, Dropdown, Button } from 'react-bootstrap';
import { FaCalendarAlt } from "react-icons/fa";
import CombinedChart from './charts/CombinedChart';
import HeartRateChart from './charts/HeartRateChart';
import RespiratoryChart from './charts/RespiratoryChart';
import EnergyChart from './charts/EnergyChart';
import HRVChart from './charts/HRVChart';

const ChartsContainer = ({ 
  chartData, 
  timeRangeType, 
  handleTimeRangeChange,
  customDateRange,
  setCustomDateRange,
  handleCustomDateApply,
  getTimeRangeDisplayText 
}) => {
  const chartProps = {
    chartData,
    timeRangeType
  };

  return (
    <>
      {/* Time Range Selector above charts */}
      <div className="d-flex justify-content-between align-items-center mb-3">
        <div>
          <h5 className="mb-0">Health Metrics Visualization</h5>
        </div>
        
        <Dropdown align="end">
          <Dropdown.Toggle variant="outline-secondary" size="sm" id="chart-time-range-dropdown">
            <FaCalendarAlt className="me-1" />
            {getTimeRangeDisplayText(timeRangeType)}
          </Dropdown.Toggle>
          <Dropdown.Menu>
            <Dropdown.Item 
              active={timeRangeType === 'today'}
              onClick={() => handleTimeRangeChange('today')}
            >
              Today
            </Dropdown.Item>
            <Dropdown.Item 
              active={timeRangeType === 'week'}
              onClick={() => handleTimeRangeChange('week')}
            >
              Last 7 Days
            </Dropdown.Item>
            <Dropdown.Item 
              active={timeRangeType === 'month'}
              onClick={() => handleTimeRangeChange('month')}
            >
              Last 30 Days
            </Dropdown.Item>
            {/* <Dropdown.Divider />
            <div className="p-3" style={{ width: '280px' }}>
              <h6 className="mb-2">Custom Date Range</h6>
              <div className="mb-2">
                <label className="form-label small mb-1">From:</label>
                <input
                  type="date"
                  className="form-control form-control-sm"
                  value={customDateRange.from}
                  onChange={(e) => setCustomDateRange(prev => ({ ...prev, from: e.target.value }))}
                />
              </div>
              <div className="mb-3">
                <label className="form-label small mb-1">To:</label>
                <input
                  type="date"
                  className="form-control form-control-sm"
                  value={customDateRange.to}
                  onChange={(e) => setCustomDateRange(prev => ({ ...prev, to: e.target.value }))}
                />
              </div>
              <Button
                variant="primary"
                size="sm"
                onClick={handleCustomDateApply}
                disabled={!customDateRange.from || !customDateRange.to}
                className="w-100"
              >
                Apply Custom Range
              </Button>
            </div> */}
          </Dropdown.Menu>
        </Dropdown>
      </div>

      {/* Chart Tabs */}
      <Tabs defaultActiveKey="combined" className="mb-3">
        <Tab eventKey="combined" title="Combined View">
          <div className="chart-container mt-3">
            <CombinedChart {...chartProps} />
          </div>
        </Tab>

        <Tab eventKey="heart" title="Heart Rate">
          <div className="chart-container mt-3">
            <HeartRateChart {...chartProps} />
          </div>
        </Tab>

        <Tab eventKey="respiratory" title="Respiratory Rate">
          <div className="chart-container mt-3">
            <RespiratoryChart {...chartProps} />
          </div>
        </Tab>

        <Tab eventKey="energy" title="Active Energy">
          <div className="chart-container mt-3">
            <EnergyChart {...chartProps} />
          </div>
        </Tab>

        <Tab eventKey="hrv" title="HRV">
          <div className="chart-container mt-3">
            <HRVChart {...chartProps} />
          </div>
        </Tab>
      </Tabs>
    </>
  );
};

export default ChartsContainer;